import { ITableInfo } from '~src/catalog/models/ITableInfo';

import { IContentInfo } from './IContentInfo';
import { ITableContentInfo } from './ITableContentInfo';

export type AnyTableType = ITableInfo | IContentInfo ;

export type CommonTableInfo = Pick<ITableContentInfo,
    'fileName' |
    'databaseName' |
    'connectionType' |
    'dbType'|
    'filePath' |
    'hostName' |
    'columns' |
    'contactName'
>;

export function getCommonTableInfo(table: AnyTableType): CommonTableInfo {
    // IContentInfo has the information inside the `contentDetail` property.
    if (isContentInfoTable(table)) {
        return {
            fileName: table.name,
            databaseName: table.contentDetail.database,
            connectionType: table.contentDetail.connectionType,
            dbType: table.contentDetail.databaseType,
            filePath: table.contentDetail.filePath?table.contentDetail.filePath: table.name,
            hostName: table.contentDetail.hostName,
            columns: table.contentDetail.columns,
            contactName: table.contentDetail.contactName,
        };
    } else {
        return {
            fileName: table.name,
            databaseName: table.database.name,
            connectionType: table.database.connectionType,
            dbType: table.database.__typename,
            filePath: table.database.name,
            hostName: table.database.hostName,
            columns: null,
            contactName: table.contact? table.contact.name : null,
        };
    }
}

export function getGraphQLId(table: AnyTableType): string {
    return isContentInfoTable(table) ? table.contentDetail.graphQLId : table.id;
}

export function isContentInfoTable(table: any): table is IContentInfo {
    return !!(table.contentDetail);
}
